export const constants = {
  OLP_VIEW: 'OLP_VIEW',
  CLIENT_MOBILE_PANEL: 'clientPanelMobile',
  NOT_A_CLIENT_IMAGE_PANEL: 'NotaClientImagePanel',
  NOT_A_CLIENT_PANEL: 'NotaClientPanel',
  SMART_BANNER: 'SMART_BANNER',
};
